<template>
  <div class="avue-contail yd-layout">
    <div class="avue-header yd-top-header">
      <!-- 顶部导航栏 -->
      <top />
      <tags />
    </div>

    <div class="avue-layout">
      <DrawMeu />
      <div class="">
        <!-- 顶部标签卡 -->
        <!-- 主体视图层 -->
        <div class="layout-scroll">
          <template v-if="hasAuth">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive" :key="$route.path" />
            </keep-alive>
            <router-view class="avue-view" v-if="!$route.meta.keepAlive" :key="$route.path" />
          </template>
          <div v-else class="flex-center flex-col full">
            <div style="color: #434e59; font-size: 72px; font-weight: 600">401</div>
            <div class="margin-top-40" style="color: #434e59; font-size: 24px; font-weight: 600"
              >您暂无{{ $route.name }}权限哦~ 再看就把你吃掉！
            </div>
          </div>
          <draggable-icon />
        </div>
      </div>
    </div>
    <div class="avue-shade" @click="showCollapse"></div>
    <search-article />
  </div>
</template>

<script>
  import DraggableIcon from '@/components/DraggableIcon'
  import { mapGetters } from 'vuex'
  import tags from './tags'
  import top from './top/'
  import DrawMeu from './draw-menu'
  import { getScreen } from '@/util'
  import searchArticle from '@/components/search-article/search-article'
  import watermark from '@/plugins/plugins.watermark'

  import { replacePhone } from '@/util/util.regx'
  import { isEmpty } from 'lodash-es'
  import useDriverStep from '@/hooks/useDriverStep'
  export default {
    setup() {
      useDriverStep()
    },
    components: {
      top,
      tags,
      searchArticle,
      DraggableIcon,
      DrawMeu
    },
    name: 'index',
    data() {
      return {
        // 刷新token锁
        refreshLock: false,
        // 刷新token的时间
        refreshTime: '',
        hasAuth: false
      }
    },
    mounted() {
      this.init()
      this.handlerSetWaterMark()
    },

    watch: {
      userInfo: {
        handler(val) {
          if (isEmpty(val)) {
            return
          }
          this.handlerSetWaterMark()
        },
        immediate: true
      },
      $route: {
        handler(v) {
          const { permission = '' } = v.meta || {}
          const allPermission = this.$store.state.user.acpermission || []
          this.hasAuth = allPermission.includes(permission) || permission === '*'
        },
        immediate: true
      }
    },
    computed: {
      ...mapGetters(['isLock', 'website', 'userInfo'])
    },
    props: [],
    methods: {
      handlerSetWaterMark() {
        const val = this.userInfo

        if (isEmpty(val)) {
          return
        }
        const { username, phone } = val
        const p = replacePhone(phone)

        watermark.set(p, username)
      },
      showCollapse() {
        this.$store.commit('SET_COLLAPSE')
      },
      // 屏幕检测
      init() {
        this.$store.commit('SET_SCREEN', getScreen())
        window.onresize = () => {
          setTimeout(() => {
            this.$store.commit('SET_SCREEN', getScreen())
          }, 0)
        }
      }
    }
  }
</script>
<style lang="scss">
  .driverjs-blue {
    background-color: #4292ff !important;
    color: #ffff !important;
    .driver-popover-close-btn {
      color: #ffff !important;
    }
    .driver-popover-progress-text {
      color: #ffff !important;
    }
    .driver-popover-prev-btn {
      &:hover {
        background-color: #6fabff !important;
      }
      border: 1px solid #ffffff;
      border-radius: 14px;
      color: #ffffff;
      background-color: #4292ff;
      text-shadow: 0px 0px 0 #fff;
    }
    .driver-popover-next-btn {
      &:hover {
        background-color: #6fabff !important;
      }
      border: 1px solid #ffffff;
      border-radius: 14px;
      color: #ffffff;
      background-color: #4292ff;
      text-shadow: 0px 0px 0 #fff;
    }
    .driver-popover-footer button:hover,
    .driver-popover-footer button:focus {
      background-color: #4292ff;
    }
  }
  .driver-popover.driverjs-blue .driver-popover-arrow-side-right.driver-popover-arrow {
    border-right-color: #4292ff !important;
  }
  .driverjs-white {
    .driver-popover-prev-btn {
      display: none !important;
    }
    .driver-popover-next-btn {
      &:hover {
        background-color: #6fabff !important;
      }
      border: 1px solid #ffffff;
      border-radius: 14px;
      color: #ffffff;
      background-color: #4292ff;
      text-shadow: 0px 0px 0 #fff;
    }
    .driver-popover-footer button:hover,
    .driver-popover-footer button:focus {
      background-color: #4292ff;
    }
  }
  .yd-top-header {
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    // height: 56px;
    background-color: #fff;
    z-index: 100;
  }
  .yd-layout {
    padding-top: 96px;
  }
  .layout-scroll {
    height: 100%;
    overflow: initial;
  }
</style>
